import { combineReducers } from '@reduxjs/toolkit';
import popupReducer from './generalSlices/popupSlice';

import cotizacionReducer from '../sections/cotizacion/components/state-combiner';

import ordenReducer from '../sections/orden/components/state-combiner';

import clienteReducer from '../sections/cliente/components/state-combiner';

import productoReducer from '../sections/producto/components/state-combiner';

import matrizReducer from '../sections/matriz/components/state-combiner';

import facturacionReducer from '../sections/facturacion/components/state-combiner';

import remitoReducer from '../sections/remito/components/state-combiner';

import reciboReducer from '../sections/recibo/components/state-combiner';

import proyectoReducer from '../sections/proyecto/components/state-combiner';

import proveedorReducer from '../sections/proveedor/components/state-combiner';

import proyectoTareasReducer from '../sections/proyectoTareas/components/state-combiner';

import insumoReducer from '../sections/insumo/components/state-combiner';

import insumoProveedorReducer from '../sections/insumoProveedor/components/state-combiner';

import insumoProveedorStockReducer from '../sections/insumoProveedorStock/components/state-combiner';

import comprasReducer from '../sections/compras/components/state-combiner';
import productoStockReducer from 'src/sections/productoStock/components/state-combiner';

const rootReducer = combineReducers({
  cotizacion: cotizacionReducer,

  orden: ordenReducer,

  cliente: clienteReducer,

  producto: productoReducer,

  matriz: matrizReducer,

  facturacion: facturacionReducer,

  remito: remitoReducer,

  recibo: reciboReducer,

  proyecto: proyectoReducer,

  proveedor: proveedorReducer,

  proyectoTareas: proyectoTareasReducer,

  insumo: insumoReducer,

  insumoProveedor: insumoProveedorReducer,

  insumoProveedorStock: insumoProveedorStockReducer,

  compras: comprasReducer,

  popup: popupReducer,
  productoStock: productoStockReducer,
});

export default rootReducer;
